import React from 'react';
import Opiniones from "./Opiniones";

const Casinos = () => {
    return (
        <Opiniones type={"casinos"} title={"LOS MEJORES CASINOS ONLINE " + new Date().getFullYear()}/>
    );
}

export default Casinos;